module.exports = __webpack_public_path__ + "img/XSG.aaa06082.svg";